import * as r from "react";
import { useState as i, useEffect as d } from "react";
const l = "\\e623", p = "\\e80b", u = "\\e906", m = "\\e907", g = "\\e908", x = "\\e909", F = "\\e901", b = "\\e903", h = "\\e902", I = "\\edcd", A = "\\ea36", E = "\\e624", f = "\\e600", w = "\\e600", v = "\\e601", C = "\\e602", y = "\\e603", k = "\\e604", D = "\\e605", S = "\\e606", $ = "\\e607", N = "\\e607", P = "\\e608", B = "\\e609", R = "\\e60a", z = "\\e60b", T = "\\e60c", Z = "\\e60d", L = "\\e60e", V = "\\e60f", U = "\\e610", _ = "\\e611", O = "\\e612", M = "\\e613", W = "\\e614", q = "\\e614", G = "\\e615", H = "\\e615", j = "\\e616", Q = "\\e617", J = "\\e618", K = "\\e619", X = "\\e61a", Y = "\\e61b", oo = "\\e61c", eo = "\\e61d", to = "\\e61e", no = "\\e61f", co = "\\e620", ro = "\\e621", so = "\\e622", ao = "\\e623", io = "\\e625", lo = "\\e626", po = "\\e627", uo = "\\e628", mo = "\\e629", go = "\\e62a", xo = "\\e62b", Fo = "\\e62c", bo = "\\e62d", ho = "\\e62e", Io = "\\e62f", Ao = "\\e630", Eo = "\\e631", fo = "\\e632", wo = "\\e633", vo = "\\e634", Co = "\\e635", yo = "\\e636", ko = "\\e637", Do = "\\e638", So = "\\e639", $o = "\\e63a", No = "\\002b", Po = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addIcon: No,
  arrowBackIcon: W,
  arrowDropdownIcon: y,
  arrowDropupIcon: k,
  arrowForwardIcon: G,
  arrowLeftIcon: q,
  arrowRightIcon: H,
  arrowSelectIcon: X,
  atIcon: u,
  boxCheckedIcon: B,
  boxEmptyIcon: R,
  budgetBillIcon: Do,
  cancelIcon: T,
  checkmarkIcon: z,
  chevronLeftIcon: J,
  chevronRightIcon: K,
  clipboardIcon: D,
  commentIcon: to,
  commercialIcon: v,
  copyIcon: eo,
  customerIcon: N,
  dashboardIcon: C,
  dateIcon: O,
  documentIcon: oo,
  downArrowIcon: A,
  downIcon: Q,
  editIcon: lo,
  emailIcon: m,
  errorIcon: V,
  fuelRewardsIcon: so,
  globeIcon: p,
  goGreenIcon: E,
  helpIcon: U,
  homeIcon: w,
  industrialIcon: h,
  infoIcon: _,
  launchIcon: no,
  linkIcon: co,
  locationIcon: Fo,
  lockIcon: io,
  mailIcon: xo,
  mailboxIcon: ro,
  notAllowedIcon: Z,
  notificationsIcon: po,
  notificationsOnIcon: uo,
  offerPromoIcon: ao,
  phoneCallIcon: mo,
  productElectricIcon: vo,
  productGasIcon: fo,
  productHomeWarrantyIcon: wo,
  productSolarIcon: Co,
  productThermostatIcon: yo,
  productWaterHeaterIcon: ko,
  removeIcon: P,
  resendIcon: Y,
  residentialIcon: f,
  searchIcon: S,
  shoppingCartIcon: bo,
  signalIcon: go,
  smokeDetectorIcon: x,
  smokeDetectorSimpleIcon: b,
  socialFacebookIcon: So,
  socialTwitterIcon: $o,
  starIcon: ho,
  swapIcon: Io,
  tagIcon: l,
  thermostatIcon: g,
  thermostatSimpleIcon: F,
  timeIcon: M,
  trendingDownIcon: Ao,
  trendingUpIcon: Eo,
  upArrowIcon: I,
  upIcon: j,
  userIcon: $,
  warningIcon: L
}, Symbol.toStringTag, { value: "Module" })), ce = {
  brand: {
    primary: {
      blue: "#005CB9",
      green: "#2FB88A",
      skyGradient: "linear-gradient(to top right, #005EB8 15%, #00BFB3 50%, #71CC98 85%);",
      washedCotton: "#FFFCF2"
    },
    secondary: {
      deepSea: "#004987",
      sunshine: "#FCD823",
      robinsEgg: "#0CBAB4",
      sunsetSky: "#F5A800",
      freshGrass: "#71C597",
      rustOrange: "#CE7B28",
      spruce: "#01524D",
      carbonNeutral: "#3D3936"
    }
  },
  materialTheme: {
    primary: {
      primary: "#069AAA",
      primaryVariant: "#006B7B"
    },
    secondary: {
      secondary: "#037AC9",
      secondaryVariant: "#004F98"
    },
    backdrop: {
      background: "#FAFAFA",
      surface: "#FFFFFF",
      divider: "#E4E4E4",
      error: "#AF272F"
    },
    text: {
      onPrimary: "#FFFFFF",
      onSecondary: "#FFFFFF",
      onBackground: "#212121",
      onSurface: "#212121",
      onError: "#FFFFFF"
    }
  },
  button: {
    background: {
      enabled: "#037AC9",
      disabled: "#E0E0E0",
      hover: "#004F98",
      focused: "#037AC999"
    },
    border: {
      enabled: "#037AC9",
      disabled: "#E0E0E0",
      hover: "#004F98",
      focused: "#037AC9"
    }
  },
  backdrop: {
    background: "#FAFAFA",
    surface: "#FFFFFF",
    divider: "#E4E4E4",
    negative: "#AF272F",
    positive: "#2E7D32",
    warn: "#F9A825",
    selected: "#E0F7FA",
    hover: "#2121210A",
    inactive: "#E0E0E0"
  },
  status: {
    active: "#43A047",
    prospect: "#F9A825",
    inactive: "#9E9E9E"
  },
  icons: {
    darkMedium: "#21212199",
    white: "#FFFFFF",
    negative: "#AF272F",
    secondary: "#037AC9"
  },
  field: {
    border: {
      active: "#CECECE;",
      focused: "#069AAA;",
      hover: "#212121",
      inactive: "#E4E4E4",
      error: "#AF272F",
      disabled: "#E0E0E0"
    },
    checkbox: "#037AC9"
  },
  text: {
    dark: "#212121",
    light: "#FFFFFF",
    negative: "#AF272F",
    interactive: "#037AC9"
  }
}, re = {
  none: "0px 0px 0px 0px rgba(0, 0, 0, .2), 0px 0px 0px 0px rgba(0, 0, 0, .14), 0px 0px 0px 0px rgba(0, 0, 0, .12);",
  lowest: "0px 0px 3px 0px rgba(0, 0, 0, 0.16), 0px 1px 1px 0px rgba(0, 0, 0, 0.26)",
  low: "0px 2px 10px 0px rgba(0, 0, 0, 0.16), 0px 2px 5px 0px rgba(0, 0, 0, 0.26)",
  medium: "0px 2px 9px 0px rgba(0, 0, 0, 0.15), 0px 5px 7px 0px rgba(0, 0, 0, 0.19)",
  high: "0px 6px 11px 0px rgba(0, 0, 0, 0.14), 0px 8px 9px 0px rgba(0, 0, 0, 0.17)",
  highest: "0px 7px 18px 0px rgba(0, 0, 0, 0.19), 0px 9px 14px 0px rgba(0, 0, 0, 0.22)"
}, se = {
  light: "300",
  regular: "400",
  medium: "500",
  bold: "700",
  dark: "900"
}, ae = {
  electric: "#fc9708",
  gas: "#3f97b5",
  goGreen: "#81bb01",
  homeWarranty: "#81bb01",
  smokeDetector: "#3c1053",
  solar: "#b38e2e",
  thermostat: "#3c1053"
}, ie = {
  none: "0",
  tiny: "2px",
  extraSmall: "4px",
  small: "8px",
  medium: "12px",
  default: "12px",
  large: "16px",
  extraLarge: "32px",
  huge: "64px"
}, de = Po, le = (o) => {
  const [e, t] = r.useState(o || 1);
  return {
    currentPage: e,
    forward: () => t(e + 1),
    backward: () => t(e - 1),
    goToPage: (a) => t(a)
  };
}, Bo = (o) => {
  const [e, t] = r.useState(o || !1);
  return {
    value: e,
    setValue: t,
    toggle: () => t(!e)
  };
}, pe = (o = !1) => {
  const { value: e, setValue: t, toggle: n } = Bo(o);
  return {
    isExpanded: e,
    onWrapperBlur: () => t(!1),
    onExpandElementClick: (c) => {
      c.stopPropagation(), n();
    },
    onContentMouseDown: (c) => c.preventDefault(),
    onExpandedElementClick: () => t(!1),
    expand: () => t(!0),
    collapse: () => t(!1)
  };
}, ue = (o, e) => {
  const [t, n] = i(o);
  return d(() => {
    const c = setTimeout(() => {
      n(o);
    }, e);
    return () => {
      clearTimeout(c);
    };
  }, [o, e]), t;
};
var Ro = /* @__PURE__ */ ((o) => (o.Local = "local", o.Dev = "dev", o.Int = "int", o.Qa = "qa", o.Prod = "prod", o.Con1 = "con1", o.Con2 = "con2", o.Con3 = "con3", o.Con4 = "con4", o.Trn = "trn", o))(Ro || {});
const s = (o) => (e) => {
  const t = e && typeof e == "number" ? e : e && e !== "$" && typeof e == "string" ? parseFloat(e) : 0;
  return `$${new Intl.NumberFormat("en-US", { maximumFractionDigits: o, minimumFractionDigits: o }).format(t)}`;
}, me = s(2), ge = s(4), zo = /^(http|https):\/\/(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}[.]?/, To = /^((http|https):\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}[.]?/, Zo = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/, Lo = /[^0-9]/g, Vo = /^0+([0-9]+)/, Uo = (
  // tslint:disable-next-line:max-line-length
  /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/
), _o = (o) => o.replace(Vo, "$1"), Oo = (o) => {
  const e = o.length - 2, t = o.substring(e);
  return `${_o(o.substring(0, e))}.${t}`;
}, Mo = (o) => {
  const t = o.length;
  return t >= 3 ? o : `${"0".repeat(3 - t)}${o}`;
}, Wo = (o) => o.replace(Lo, ""), xe = (o) => `${Oo(Mo(Wo(o)))}`, qo = "Required", Go = "Must be numeric", Ho = "Must be alpha-numeric", Fe = "Amount must be greater than zero", jo = "Invalid Phone Number", Qo = "Url is in an invalid format (does the url begin with http or https?)", Jo = "Url is in an invalid format", Ko = "Invalid Email Address", Xo = (o) => `Over ${o} character limit`, Yo = (o) => `Under ${o} character limit`, oe = (o) => `Expected the value to be ${o}`, ee = (o) => o ? void 0 : qo, be = (o) => (e) => o ? ee(e) : void 0, he = (o) => (e) => e && e.toString().length > o ? Xo(o) : void 0, Ie = (o) => (e) => e && e.toString().length < o ? Yo(o) : void 0, Ae = (o) => !o || /^[\w ']+$/.test(o) ? void 0 : Ho, Ee = (o) => !o || /(^\d+$)|(^-?(.|[0-9])\d*\.?\d*[^.]$)/.test(o) ? void 0 : Go, fe = (o) => !o || zo.test(o) ? void 0 : Qo, we = (o) => !o || To.test(o) ? void 0 : Jo, ve = (o) => !o || Zo.test(o) ? void 0 : Ko, Ce = (o) => !o || Uo.test(o) ? void 0 : jo, ye = (o) => (e) => o === e ? void 0 : oe(o), ke = process.env.NODE_ENV === "development", De = process.env.NODE_ENV === "production";
export {
  ce as ColorPalette,
  re as Elevation,
  oe as ExpectedValueDoesNotMatch,
  se as FontWeight,
  ke as IS_DEV,
  De as IS_PROD,
  Ro as IgsEnvironment,
  ae as ProductColors,
  qo as RequiredField,
  ie as Spacing,
  Xo as TooLongField,
  Yo as TooShortField,
  No as addIcon,
  W as arrowBackIcon,
  y as arrowDropdownIcon,
  k as arrowDropupIcon,
  G as arrowForwardIcon,
  q as arrowLeftIcon,
  H as arrowRightIcon,
  X as arrowSelectIcon,
  u as atIcon,
  B as boxCheckedIcon,
  R as boxEmptyIcon,
  Do as budgetBillIcon,
  T as cancelIcon,
  z as checkmarkIcon,
  J as chevronLeftIcon,
  K as chevronRightIcon,
  D as clipboardIcon,
  to as commentIcon,
  v as commercialIcon,
  eo as copyIcon,
  N as customerIcon,
  C as dashboardIcon,
  O as dateIcon,
  oo as documentIcon,
  A as downArrowIcon,
  Q as downIcon,
  lo as editIcon,
  Zo as emailAddressRegex,
  m as emailIcon,
  V as errorIcon,
  me as formatAsCurrency,
  ge as formatAsUtilityRate,
  so as fuelRewardsIcon,
  p as globeIcon,
  E as goGreenIcon,
  ye as hasExpectedValue,
  U as helpIcon,
  w as homeIcon,
  zo as httpUrlRegex,
  de as iconTypes,
  h as industrialIcon,
  _ as infoIcon,
  Ko as invalidEmailAddress,
  Qo as invalidHttpUrl,
  jo as invalidPhoneNumber,
  Jo as invalidUrl,
  Ee as isAllNumbers,
  Go as isAllNumbersError,
  Fe as isPositiveAmountError,
  Ae as isValidName,
  Ho as isValidNameError,
  no as launchIcon,
  co as linkIcon,
  Fo as locationIcon,
  io as lockIcon,
  xo as mailIcon,
  ro as mailboxIcon,
  Lo as matchAllNonNumericCharsRegex,
  he as maxLength,
  Ie as minLength,
  Z as notAllowedIcon,
  po as notificationsIcon,
  uo as notificationsOnIcon,
  Vo as numberWithLeadingZerosRegex,
  ao as offerPromoIcon,
  xe as parseCurrency,
  mo as phoneCallIcon,
  Uo as phoneNumberRegex,
  vo as productElectricIcon,
  fo as productGasIcon,
  wo as productHomeWarrantyIcon,
  Co as productSolarIcon,
  yo as productThermostatIcon,
  ko as productWaterHeaterIcon,
  P as removeIcon,
  ee as required,
  Y as resendIcon,
  f as residentialIcon,
  S as searchIcon,
  bo as shoppingCartIcon,
  go as signalIcon,
  x as smokeDetectorIcon,
  b as smokeDetectorSimpleIcon,
  So as socialFacebookIcon,
  $o as socialTwitterIcon,
  be as sometimesRequired,
  ho as starIcon,
  Io as swapIcon,
  l as tagIcon,
  g as thermostatIcon,
  F as thermostatSimpleIcon,
  M as timeIcon,
  Ao as trendingDownIcon,
  Eo as trendingUpIcon,
  I as upArrowIcon,
  j as upIcon,
  To as urlRegex,
  Bo as useBoolean,
  ue as useDebounce,
  pe as useExpandable,
  le as usePaging,
  $ as userIcon,
  ve as validEmail,
  fe as validHttpUrl,
  Ce as validPhoneNumber,
  we as validUrl,
  L as warningIcon
};
